import { render, staticRenderFns } from "./AdminLandingView.vue?vue&type=template&id=1a036161"
import script from "./AdminLandingView.vue?vue&type=script&lang=ts"
export * from "./AdminLandingView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports